//Paquetes NPM de GYF. 
import { Engine1Proxy, RestApiProxy, ConciergeProxy } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

// ACTION TYPES
export const GET_SCREEN_DATA_PERMIPORPERF_STARTS = "GET_SCREEN_DATA_PERMIPORPERF_STARTS";
export const SET_USER_FUNCTIONS_PERMIPORPERF = "SET_USER_FUNCTIONS_PERMIPORPERF";
export const GET_SCREEN_DATA_PERMIPORPERF_SUCCESS = "GET_SCREEN_DATA_PERMIPORPERF_SUCCESS"; 
export const INITIAL_STATE_PERMISOS_PERFIL = "INITIAL_STATE_PERMISOS_PERFIL";
export const GET_PERMISSIONS_BY_PROFILE = "GET_PERMISSIONS_BY_PROFILE"; 
export const SET_TITLE_PERMIPORPERF = "SET_TITLE_PERMIPORPERF";

let _currentScope = null;
let _dispatch = null;
let _id = null;
let _title2 = null;

/**
 * Obtiene los datos para popular la pantalla.
 * @param {any} id
 * @param {any} currentScope
 */
export function getScreenData(id, currentScope) {
    LogHelper.In(getScreenData.name, id, currentScope);

    _id = id;

    return (dispatch, getState) => {
        _currentScope = currentScope;
        _dispatch = dispatch;
        dispatch({ type: GET_SCREEN_DATA_PERMIPORPERF_STARTS });

        var currentScopeRequest = {
            "UserId": _currentScope.UserId,
            "ProductCode": _currentScope.ProductCode,
            "ProgramCode": _currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _loadScreenData(data), null, "GETFUNCTIONS", currentScopeRequest, null, "SEGURIDAD");
    }

    LogHelper.Out(getScreenData.name, id, currentScope);
}

/**
 * Vuelve el estado de la pantalla al inicial de la misma.
 */
export function resetStatePerPorPerf() {

    LogHelper.In(resetStatePerPorPerf.name);

    return (dispatch) => {
        dispatch({ type: INITIAL_STATE_PERMISOS_PERFIL });
    }

    LogHelper.Out(resetStatePerPorPerf.name);
}




/** ------------------------------     FUNCIONES AUXILIARES    --------------------------------  **/

/**
 * Funcion callback de los datos principales para popular la pantalla.
 * @param {any} data
 */
function _loadScreenData(data) {
    LogHelper.In(_loadScreenData.name, data);

    let functions = data.SEGURIDAD;
    functions.forEach(p => { functions[p.Codigo_Funcion] = true; });

    _dispatch({ type: SET_USER_FUNCTIONS_PERMIPORPERF, functions });

    let param = {
        'PERFIL_ID': _id
    };

    Engine1Proxy.AddDataSourcesRequests(param, 'GET_PERFIL_BY_ID', "Get", _currentScope.ProductCode, "SEGURIDAD", "Product", 1); 
    Engine1Proxy.AddDataSourcesRequests(param, 'GET_CATEGORIAS_BY_PROFILE', "Get", _currentScope.ProductCode, "SEGURIDAD", "Product", 1);


    Engine1Proxy.Execute(_loadUserListInitialStateData, null, null, "SEGURIDAD");

    LogHelper.Out(_loadScreenData.name, data);
}


/**
 * Funcion que parsea los datos recibidos del Engine1 para retornarlos a pantalla.
 * @param {any} data
 */
function _loadUserListInitialStateData(data) {
    LogHelper.In(_loadUserListInitialStateData.name, data);

    let result = {
        "GET_CATEGORIAS_BY_PROFILE": JSON.parse(data.GET_CATEGORIAS_BY_PROFILE).Recordset0.Rows,
        "GET_PERFIL_BY_ID": JSON.parse(data.GET_PERFIL_BY_ID).Recordset0.Rows
    }

    if (JSON.parse(data.GET_PERFIL_BY_ID).Recordset0.Rows != undefined) {
        _title2 = JSON.parse(data.GET_PERFIL_BY_ID).Recordset0.Rows;
        _dispatch({ type: SET_TITLE_PERMIPORPERF, _title2 });
    }

    _dispatch({ type: GET_SCREEN_DATA_PERMIPORPERF_SUCCESS, result: result });

    LogHelper.Out(_loadUserListInitialStateData.name, data);
}